<template>
	<div class="wrapper">
		<!--头部导航 GO-->
		<div class="titbar">
			<img class="bg-tit" src="@/assets/bg-tit.png" alt="">
			<span>党建一张图</span>
			<div class="dot-l">
				<img src="@/assets/dot.gif" alt="">
			</div>
			<div class="dot-r">
				<img src="@/assets/dot.gif" alt="">
			</div>
		</div>
		<section class="container">
			<section class="cont-left">
				<!--左1 GO-->
				<div class="area3 arrow-n-line">
					<div class="arrow-up"></div>
					<div class="arrow-down"></div>
					<div class="item first">
						<div class="tit">
							人大代表情况
						</div>
						<div class="char" id="char1"></div>
					</div>

					<div class="item last">
						<div class="tit">
							政协委员情况
						</div>
						<div class="char" id="pieChart"></div>
					</div>

				</div>
				<!--左2 GO-->
				<div class="area2 arrow-n-line">
					<div class="arrow-up"></div>
					<div class="arrow-down"></div>
					<div class="item first">
						<div class="tit">
							地域分布
						</div>
						<div class="char-wrap">
							<div class="char" id="char3"></div>
							<div class="circle"></div>
						</div>
					</div>

					<div class="item last">
						<div class="tit">
							界别情况
						</div>
						<div class="char" id="char4"></div>
					</div>

				</div>
				<!--左3 GO-->
				<div class="area1 arrow-n-line">
					<div class="arrow-up"></div>
					<div class="arrow-down"></div>
					<div class="item first">
						<div class="tit">
							主界别会员
						</div>
						<div class="char" id="char5"></div>
					</div>

					<div class="item last">
						<div class="tit">
							年龄分布 <div class="age">平均年龄 <span>50</span>岁</div>
						</div>
						<div class="char" id="char6"></div>
					</div>
				</div>
			</section>
			<section class="cont-center">
				<!--中1 GO-->
				<div class="area4 arrow-n-line">
					<div class="arrow-up"></div>
					<div class="arrow-down"></div>
					<div class="item item1">
						<div class="num">5827</div>
						<div class="txt">会员总数</div>
					</div>
					<div class="item item2">
						<div class="num">27</div>
						<div class="txt">女会员</div>
					</div>
					<div class="item item3">
						<div class="num">27</div>
						<div class="txt">退休会员</div>
					</div>
					<div class="item item4">
						<div class="num">827</div>
						<div class="txt">党派交叉会员</div>
					</div>

				</div>
				<!--中2 GO-->
				<div class="area5 arrow-n-line">
					<div class="arrow-up"></div>
					<div class="arrow-down"></div>
					<div class="item">
						<div class="tit">
							职称情况
						</div>
						<div class="char" id="char7"></div>
					</div>
				</div>
			</section>
			<section class="cont-right">
				<!--右1 GO-->
				<div class="area6 arrow-n-line">
					<div class="arrow-up"></div>
					<div class="arrow-down"></div>
					<div class="item">
						<div class="tit">
							学历情况
						</div>
						<div class="char" id="char8"></div>
					</div>
				</div>
				<!--右2 GO-->
				<div class="area7 arrow-n-line">
					<div class="arrow-up"></div>
					<div class="arrow-down"></div>
					<div class="item">
						<div class="tit">
							行政级别
						</div>
						<div class="char" id="char9"></div>
					</div>
				</div>
			</section>
			<!--右下角 GO-->
			<section class="cont-bottom">
				<div class="area8 arrow-n-line">
					<div class="arrow-up"></div>
					<div class="arrow-down"></div>
					<div class="char" id="char10"></div>
				</div>
			</section>

		</section>
	</div>
</template>


<script>
	import * as echarts from "echarts";
	import 'echarts-gl';
	export default {
		name: 'ScreenData',
		props: {
			datas: Array,
			defalut: () => {}
		},
		data() {
			return {
				timer: {}
			}
		},

		destroyed() {
			clearInterval(this.timer); //先随机产生数字当作初始化的值
		},

		mounted() {
			this.handlePart1(); //第1区域：左饼图
			this.handlePieChart(); //第1区域：右3D饼图
			this.handlePart2(); //第2区域：饼图+柱状图
			this.handlePart3(); //第3区域：柱状图+柱状图
			this.handlePart4(); //第4区域：4项统计
			this.handlePart5(); //第5区域：饼图
			this.handlePart6(); //第6区域：饼图
			this.handlePart7(); //第7区域：3D柱状
			this.handlePart8(); //第8区域：折柱混合


		},
		methods: {
			/**
			 * 人大代表情况 饼图GO
			 * */
			handlePart1() {
				var setChart1 = echarts.init(document.getElementById('char1'));
				var legendData1 = [{
						value: 1048,
						name: '国家级'
					},
					{
						value: 735,
						name: '省级'
					},
					{
						value: 580,
						name: '市级'
					},
					{
						value: 484,
						name: '区县级'
					}
				]
				let option5 = {
					tooltip: {
						trigger: 'item'
					},
					legend: {
						// data: legendData,
						itemWidth: 15, //色标图宽
						itemHeight: 7, //色标图高
						orient: 'vertical', //垂直显示  
						top: 50,
						right: 0,
						itemGap: 25, //色标间隔
						textStyle: {
							color: '#fff',
							fontSize: 14
						},
						formatter: function(params) {
							var legendIndex = 0;
							legendData1.forEach(function(v, i) {
								if (v.name == params) {
									legendIndex = i;
								}
							});
							return params + " " + legendData1[legendIndex].value + "人";
						}
					},
					series: [{
						type: 'pie',
						radius: '50%',
						center: ["140px", "50%"],
						data: legendData1,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				setChart1.setOption(option5);
				window.addEventListener('resize', () => {
					setChart1.resize();
				});
			},


			/**
			 * 地域分布 界别情况 饼图GO
			 * */
			handlePart2() {
				var setChart3 = echarts.init(document.getElementById('char3'));
				var setChart4 = echarts.init(document.getElementById('char4'));
				let option3 = {
					series: [{
						name: '地域分布',
						type: 'pie',
						radius: ['40%', '50%'],
						center: ['50%', '50%'],
						avoidLabelOverlap: false,
						itemStyle: {
							borderRadius: 0,
							borderWidth: 3, //设置border的宽度有多大
							borderColor: '#010324', //这里的颜色修改为背景颜色就行
						},
						label: { //文本样式
							normal: {
								textStyle: {
									fontSize: 14, // 改变标示文字的大小
									color: '#f1f1fe'
								}
							}
						},
						labelLine: { //指示线样式设置
							length: 0 //第一段指示线的长度
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 30,
							}
						},
						data: [{
								value: 1048,
								name: '福州 1048',
								itemStyle: {
									color: '#b39f70'
								}
							},
							{
								value: 835,
								name: '厦门 835',
								itemStyle: {
									color: '#faab76'
								}
							},
							{
								value: 535,
								name: '漳州 535',
								itemStyle: {
									color: '#5555ff'
								}
							},
							{
								value: 735,
								name: '泉州 735',
								itemStyle: {
									color: '#34ccda'
								}
							},
							{
								value: 135,
								name: '龙岩 135',
								itemStyle: {
									color: '#dd65a5'
								}
							},
							{
								value: 1350,
								name: '省直 1350',
								itemStyle: {
									color: '#f9b475'
								}
							},
							{
								value: 735,
								name: '宁德 735',
								itemStyle: {
									color: '#2388be'
								}
							},
							{
								value: 735,
								name: '三明 735',
								itemStyle: {
									color: '#6e7dbe'
								}
							},
							{
								value: 735,
								name: '莆田 735',
								itemStyle: {
									color: '#6f3abe'
								}
							},
							{
								value: 735,
								name: '南平 735',
								itemStyle: {
									color: '#ed5fa3'
								}
							}
						]
					}]
				};

				let legendData4 = [348, 903, 497, 174, 348, 903, 497, 174, 348, 903, 497, 174, 348, 903]
				const sum4 = legendData4.reduce((accumulator, currentValue) => {
					return accumulator + currentValue;
				});

				let option4 = {
					grid: {
						left: '0px',
						right: '100',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						boundaryGap: [0, 0.01],
						splitLine: {
							show: false //去掉网格线
						},
						//设置坐标轴字体颜色和宽度
						axisLine: { //这是x轴文字颜色
							show: false,
							lineStyle: {
								color: "#bff7ff",
							}
						},
						axisLabel: {
							show: false,
							interval: 0,
							rotate: 45 // 角度
						}
					},
					yAxis: {
						type: 'category',
						data: ['其他 ', '新的社会阶层人士', '非公有制经济', '公有制经济', '团体', '医药卫生', '司法机关', '党派机关', '人大政协机关', '科学技术',
							'出版传媒', '文化艺术', '普通教育', '高等教育'
						],
						axisTick: { //隐藏刻度
							show: false
						},
						splitLine: {
							show: false //去掉网格线
						},
						//设置坐标轴字体颜色和宽度
						axisLine: { //这是x轴文字颜色
							show: false, //去掉Y轴
							lineStyle: {
								color: "#bff7ff",
							}
						}


					},
					series: [{
						name: '界别情况',
						type: 'bar',
						barWidth: 10,
						data: legendData4,
						label: { //柱状顶部显示数值
							normal: {
								show: true,
								position: 'right',
								offset: [5, -2],
								formatter: function(params) {
									return legendData4[params.dataIndex] + '人 (' + ((legendData4[params
										.dataIndex] / sum4 * 100)).toFixed(2) + '%)'
								},
								textStyle: {
									color: '#00ffff',
									fontSize: 13
								}
							}
						},
						itemStyle: {
							emphasis: {
								barBorderRadius: 7
							},
							normal: {
								barBorderRadius: 7,
								//这里是重点
								color: function(params) {
									//注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
									var colorList = ['#006492', '#01d9d8', '#0086ce', '#b78bef', '#006492',
										'#01d9d8', '#0086ce', '#b78bef', '#01d9d8', '#0086ce',
										'#b78bef', '#006492',
										'#01d9d8', '#0086ce', '#b78bef', '#01d9d8', '#0086ce',
										'#b78bef', '#006492',
										'#01d9d8', '#0086ce', '#b78bef'
									];
									var index;
									//给大于颜色数量的柱体添加循环颜色的判断
									if (params.dataIndex >= colorList.length) {
										index = params.dataIndex - colorList.length;
										return colorList[index];
									}
									return colorList[params.dataIndex];
								}
							}
						}

					}]
				};



				setChart3.setOption(option3);
				setChart4.setOption(option4);
				window.addEventListener('resize', () => {
					setChart3.resize();
					setChart4.resize();
				});



			},

			/**
			 * 主界别会员 年龄分布 柱状图GO
			 * */
			handlePart3() {
				var setChart5 = echarts.init(document.getElementById('char5'));
				var setChart6 = echarts.init(document.getElementById('char6'));
				var legendData5 = [1820, 2348, 2903, 10497, 13174]
				var legendData6 = [2348, 2903, 3497, 2174]

				const sum5 = legendData5.reduce((accumulator, currentValue) => {
					return accumulator + currentValue;
				});
				const sum6 = legendData6.reduce((accumulator, currentValue) => {
					return accumulator + currentValue;
				});


				let option5 = {
					grid: {
						left: '10px',
						right: '100px',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						boundaryGap: [0, 0.01],
						splitLine: {
							show: false //去掉网格线
						},
						//设置坐标轴字体颜色和宽度
						axisLine: { //这是x轴文字颜色
							lineStyle: {
								color: "#bff7ff",
							}
						},
						axisLabel: {
							show: false,
							interval: 0,
							rotate: 45 // 角度
						}
					},
					yAxis: {
						type: 'category',
						data: ['高等教育', '普通教育', '文化艺术', '出版传媒', '科学技术'],
						axisTick: { //隐藏刻度

							show: false

						},
						splitLine: {
							show: false //去掉网格线
						},
						//设置坐标轴字体颜色和宽度
						axisLine: { //这是x轴文字颜色
							show: false, //去掉Y轴
							lineStyle: {
								color: "#bff7ff",
							}
						}


					},
					series: [{
						name: '主界别会员',
						type: 'bar',
						barWidth: 10,
						data: legendData5,
						label: { //柱状顶部显示数值
							normal: {
								show: true,
								position: 'right',
								offset: [5, -2],

								formatter: function(params) {
									return legendData5[params.dataIndex] + ' (' + ((legendData5[params
										.dataIndex] / sum5 * 100)).toFixed(2) + '%)'
								},
								textStyle: {
									color: '#00deff',
									fontSize: 13
								}
							}
						},
						itemStyle: {
							emphasis: {
								barBorderRadius: 7
							},
							normal: {
								barBorderRadius: 7,
								color: new echarts.graphic.LinearGradient(
									0, 0, 1, 0,
									[{
											offset: 0,
											color: '#3977E6'
										},
										{
											offset: 1,
											color: '#37BBF8'
										}

									]
								)
							}
						}

					}]
				};


				let option6 = {
					grid: {
						left: '10px',
						right: '100px',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						boundaryGap: [0, 0.01],
						splitLine: {
							show: false //去掉网格线
						},
						//设置坐标轴字体颜色和宽度
						axisLine: { //这是x轴文字颜色
							show: false,
							lineStyle: {
								color: "#bff7ff",
							}
						},
						axisLabel: {
							show: false,
							interval: 0,
							rotate: 45 // 角度
						}

					},
					yAxis: {
						type: 'category',
						data: ['40岁以下', '41-50岁', '51-60岁', '60岁以上'],
						axisTick: { //隐藏刻度
							show: false
						},
						splitLine: {
							show: false //去掉网格线
						},
						//设置坐标轴字体颜色和宽度
						axisLine: { //这是x轴文字颜色
							show: false, //去掉Y轴
							lineStyle: {
								color: "#bff7ff",
							}
						}


					},
					series: [{
						name: '年龄分布',
						type: 'bar',
						barWidth: 10,
						data: legendData6,
						label: { //柱状顶部显示数值
							normal: {
								show: true,
								position: 'right',
								offset: [5, -2],

								formatter: function(params) {
									return legendData6[params.dataIndex] + ' (' + ((legendData6[params
										.dataIndex] / sum6 * 100)).toFixed(2) + '%)'
								},
								textStyle: {
									color: '#a581de',
									fontSize: 13
								}
							}
						},
						itemStyle: {
							emphasis: {
								barBorderRadius: 7
							},
							normal: {
								barBorderRadius: 7,
								color: new echarts.graphic.LinearGradient(
									0, 0, 1, 0,
									[{
											offset: 0,
											color: '#6b16d9'
										},
										{
											offset: 1,
											color: '#8152f4'
										}

									]
								)
							}
						}

					}]
				};


				setChart5.setOption(option5);
				setChart6.setOption(option6);
				window.addEventListener('resize', () => {
					setChart5.resize();
					setChart6.resize();
				});


			},


			/**
			 * 4项统计
			 * */

			handlePart4() {

			},

			/**
			 * 职称情况
			 * */

			handlePart5() {
				var setChart7 = echarts.init(document.getElementById('char7'));
				var legendData7 = [{
						value: 1048,
						name: '初级职称会员'
					},
					{
						value: 735,
						name: '中级职称会员'
					},
					{
						value: 580,
						name: '副高职称会员'
					},
					{
						value: 484,
						name: '正高职称会员'
					}
				]

				const sum7 = legendData7.reduce((accumulator, currentValue) => {

					return legendData7[0].value + currentValue.value;
				});

				let option7 = {
					legend: {
						show: true,
						orient: 'horizontal',
						bottom: '10px',
						left: '0',
						itemWidth: 15,
						itemHeight: 6,
						itemGap: 10,
						formatter: function(params) {
							var legendIndex = 0;
							legendData7.forEach(function(v, i) {
								if (v.name == params) {
									legendIndex = i;
								}
							});
							return params + " " + legendData7[legendIndex].value + "人 " + (legendData7[legendIndex]
								.value / sum7 * 100).toFixed(2) + '%';
						},
						textStyle: {
							color: '#FFFFFF',
							fontSize: 14
						},

					},
					series: [{
						name: '职称情况',
						type: 'pie',
						radius: [30, 80],
						center: ['50%', '40%'],
						roseType: 'area',
						label: {
							show: false,
							position: 'center',
							normal: { //指示线
								show: true,
								position: 'outside',
								color: '#ffffff'
							},
						},
						itemStyle: {
							borderRadius: 8,

						},
						data: legendData7
					}]
				};
				setChart7.setOption(option7);
				window.addEventListener('resize', () => {
					setChart7.resize();
				});


			},



			/**
			 * 学历情况
			 * */

			handlePart6() {
				var setChart8 = echarts.init(document.getElementById('char8'));
				var legendData8 = [{
						value: 1048,
						name: '大专会员',
						itemStyle: {
							color: '#60fcff'
						}
					},
					{
						value: 735,
						name: '大学会员',
						itemStyle: {
							color: '#a581de'
						}
					},
					{
						value: 580,
						name: '研究生会员',
						itemStyle: {
							color: '#faab76'
						}
					},
					{
						value: 580,
						name: '博士会员',
						itemStyle: {
							color: '#ffaa00'
						}
					}
				]

				const sum8 = legendData8.reduce((accumulator, currentValue) => {

					return legendData8[0].value + currentValue.value;
				});

				let option8 = {
					legend: {
						show: true,
						orient: 'horizontal',
						bottom: '10px',
						left: '0',
						itemWidth: 15,
						itemHeight: 6,
						itemGap: 10,
						formatter: function(params) {
							var legendIndex = 0;
							legendData8.forEach(function(v, i) {
								if (v.name == params) {
									legendIndex = i;
								}
							});
							return params + " " + legendData8[legendIndex].value + "人 " + (legendData8[legendIndex]
								.value / sum8 * 100).toFixed(2) + '%';
						},
						textStyle: {
							color: '#FFFFFF',
							fontSize: 14
						},

					},
					title: {
						left: 'center',
						top: 20,
						textStyle: {
							color: '#ccc'
						}
					},
					tooltip: {
						trigger: 'item'
					},
					visualMap: {
						show: false,
						min: 80,
						max: 600,
						inRange: {
							colorLightness: [0, 1]
						}
					},
					series: [{
						name: '学历情况',
						type: 'pie',
						radius: '55%',
						center: ['50%', '40%'],
						data: legendData8,
						roseType: 'radius',
						label: {

							normal: { //指示线
								show: true,
								position: 'outside',
								color: '#ffffff'
							},
						},
						labelLine: {
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.3)'
							},
							smooth: 0.2,
							length: 10,
							length2: 20
						},
						itemStyle: {
							color: '#c23531',
							shadowBlur: 200,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						},
						animationType: 'scale',
						animationEasing: 'elasticOut',
						animationDelay: function() {
							return Math.random() * 200;
						}
					}]
				};
				setChart8.setOption(option8);
				window.addEventListener('resize', () => {
					setChart8.resize();
				});


			},



			//行政级别
			handlePart7() {

				var setChart9 = echarts.init(document.getElementById('char9'));
				// var xData = ["副处级", "正处级", "副厅局级", "正厅局级", "副部级", "正部级"]

				var legendData9 = [{
						value: 1048,
						name: '副处级',
						itemStyle: {
							color: '#60fcff'
						}
					},
					{
						value: 735,
						name: '正处级',
						itemStyle: {
							color: '#f96674'
						}
					},
					{
						value: 580,
						name: '副厅局级',
						itemStyle: {
							color: '#7c61fd'
						}
					},
					{
						value: 484,
						name: '正厅局级',
						itemStyle: {
							color: '#faab76'
						}
					},

					{
						value: 580,
						name: '副部级',
						itemStyle: {
							color: '#ed5fa3'
						}
					},
					{
						value: 484,
						name: '正部级',
						itemStyle: {
							color: '#C1EBDD'
						}
					}
				]

				const sum9 = legendData9.reduce((accumulator, currentValue) => {

					return legendData9[0].value + currentValue.value;
				});

				let option9 = {
					grid: {
						left: '10px',
						right: '10px',
						bottom: '100px',
						containLabel: true
					},
					tooltip: {
						trigger: 'item'
					},
					legend: {
						show: true,
						orient: 'horizontal',
						bottom: '0px',
						left: '0px',
						right: '0px',
						itemWidth: 15,
						itemHeight: 6,
						itemGap: 10,
						formatter: function(params) {
							var legendIndex = 0;
							legendData9.forEach(function(v, i) {
								if (v.name == params) {
									legendIndex = i;
								}
							});
							return params + " " + legendData9[legendIndex].value + "人 " + (legendData9[legendIndex]
								.value / sum9 * 100).toFixed(2) + '%';
						},
						textStyle: {
							color: '#FFFFFF',
							fontSize: 14
						},

					},
					series: [{
						name: '职称情况',
						type: 'pie',
						radius: ['40%', '50%'],
						center: ['50%', '35%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center',
							normal: { //指示线
								show: true,
								position: 'outside',
								color: '#ffffff'
							},
						},
						emphasis: {
							label: {
								show: true,
								fontSize: 20,
								fontWeight: 'bold'
							}
						},
						labelLine: {
							normal: {
								show: true,
								length: 20,
								length2: 20,
								lineStyle: {
									color: '#fff'
								}
							}
						},
						data: legendData9
					}]
				};

				setChart9.setOption(option9);
				window.addEventListener('resize', () => {
					setChart9.resize();
				});
			},

			/**
			 * 会员每年新增情况
			 * */

			handlePart8() {
				var setChart10 = echarts.init(document.getElementById('char10'));

				const colors = ['#006492', '#01d9d8'];
				let option10 = {
					color: colors,
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					grid: {
						top: "50px",
						right: '70px',
						bottom: "40px"
					},

					legend: {
						data: ['会员新增数', '增长率'],
						top: 10,
						left: "center",
						textStyle: {
							color: '#fff',
							fontSize: 14
						},
					},
					xAxis: [{
						type: 'category',
						splitLine: {
							show: false
						},
						axisTick: {
							alignWithLabel: true
						},
						axisLine: {
							show: true,
							lineStyle: {
								fontSize: 20,
							}
						},

						axisLabel: {
							textStyle: {
								show: true,
								fontFamily: '微软雅黑',
								color: "#fff",
								fontSize: '16',
							},
						},
						data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026']
					}],
					yAxis: [{
							type: 'value',
							name: '会员新增数（人）',
							position: 'left',
							alignTicks: true,
							axisLine: {
								show: true,
								lineStyle: {
									color: colors[0],
									fontSize: 30,
								}
							},
							axisLabel: {
								formatter: '{value} 人',
								textStyle: {
									show: true,
									fontFamily: '微软雅黑',
									fontSize: '14',
								},

							},
							splitLine: {
								show: false
							},
						}, {
							type: 'value',
							name: '增长率（%）',
							position: 'right',
							alignTicks: true,
							offset: 0,
							axisLine: {
								show: true,
							},
							axisLabel: {
								formatter: '{value} %',
								textStyle: {
									show: true,
									fontFamily: '微软雅黑',
									color: "#00deff",
									fontSize: '14',
								},
							},
							splitLine: {
								show: false
							},
						},

					],
					series: [{
							name: '会员新增数',
							type: 'bar',
							label: { //柱状顶部显示数值
								normal: {
									show: true,
									position: 'top',
									textStyle: {
										color: '#00ffff',
										fontSize: 13
									}
								}
							},
							data: [
								333, 666, 555, 456, 359, 855, 1332, 0, 0, 0, 0, 0
							]
						},
						{
							name: '增长率',
							type: 'line',
							yAxisIndex: 1,
							data: [
								2.6, 5.9, 9.0, 26.4, 28.7, 70.7
							]
						},
					]
				};

				setChart10.setOption(option10);
				window.addEventListener('resize', () => {
					setChart10.resize();
				});


			},




			/*
			 *预警情况饼图
			 */
			handlePieChart() {
				var myChart = echarts.init(document.getElementById('pieChart'));

				var legendData3D = [{
						name: '国家级',
						value: 3,
						itemStyle: {
							opacity: 1,
							color: 'rgba(228,220,65,1)',
						}
					},
					{
						name: '省级',
						value: 1,
						itemStyle: {
							opacity: 1,
							color: 'rgba(77,157,229,1)',
						}
					},
					{
						name: '市级',
						value: 1,
						itemStyle: {
							opacity: 1,
							color: 'rgba(94,209,213,1)',
						}
					},
					{
						name: '区县级',
						value: 1,
						itemStyle: {
							opacity: 1,
							color: 'rgba(0, 170, 0, 1.0)',
						}
					}

				]

				function getParametricEquation(startRatio, endRatio, isSelected, isHovered, k, height) {
					// 计算
					// console.log("getParametricEquation")
					let midRatio = (startRatio + endRatio) / 2;
					let startRadian = startRatio * Math.PI * 2;
					let endRadian = endRatio * Math.PI * 2;
					let midRadian = midRatio * Math.PI * 2;

					if (startRatio === 0 && endRatio === 1) {
						isSelected = false;
					}

					// 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
					k = typeof k !== 'undefined' ? k : 1 / 3;

					// 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
					let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
					let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;

					// 计算高亮效果的放大比例（未高亮，则比例为 1）
					let hoverRate = isHovered ? 1.05 : 1;

					// 返回曲面参数方程
					return {

						u: {
							min: -Math.PI,
							max: Math.PI * 3,
							step: Math.PI / 32
						},

						v: {
							min: 0,
							max: Math.PI * 2,
							step: Math.PI / 20
						},

						x: function(u, v) {
							if (u < startRadian) {
								return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
							}
							if (u > endRadian) {
								return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
							}
							return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
						},

						y: function(u, v) {
							if (u < startRadian) {
								return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
							}
							if (u > endRadian) {
								return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
							}
							return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
						},

						z: function(u, v) {
							if (u < -Math.PI * 0.5) {
								return Math.sin(u);
							}
							if (u > Math.PI * 2.5) {
								return Math.sin(u);
							}
							return Math.sin(v) > 0 ? 1 * height : -1;
						}
					};
				}

				// 3D饼图的配置项，同echarjs的series
				function getPie3D(pieData, internalDiameterRatio) {
					let series = [];
					let sumValue = 0;
					let startValue = 0;
					let endValue = 0;
					let legendData = [];
					let k = typeof internalDiameterRatio !== 'undefined' ? (1 - internalDiameterRatio) / (1 +
							internalDiameterRatio) :
						1 / 3;
					// 3个饼图参数
					for (let i = 0; i < pieData.length; i++) {

						sumValue += pieData[i].value;

						let seriesItem = {
							name: typeof pieData[i].name === 'undefined' ? `series${i}` : pieData[i].name,
							type: 'surface',
							parametric: true,
							wireframe: {
								show: false
							},
							label: {
								normal: {
									position: 'inner',
									show: false
								}
							},
							labelLine: {
								normal: {
									lineStyle: {
										color: 'rgba(255, 255, 255, 0.3)'
									},
									smooth: 0.2,
									length: 50,
									length2: 100,
								}
							},
							pieData: pieData[i],
							pieStatus: {
								selected: false,
								hovered: false,
								k: k
							}
						};
						if (typeof pieData[i].itemStyle != 'undefined') {
							let itemStyle = {};
							typeof pieData[i].itemStyle.color != 'undefined' ? itemStyle.color = pieData[i].itemStyle
								.color : null;
							typeof pieData[i].itemStyle.opacity != 'undefined' ? itemStyle.opacity = pieData[i].itemStyle
								.opacity : null;
							seriesItem.itemStyle = itemStyle;
						}
						series.push(seriesItem);
					}

					// 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
					// 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
					for (let i = 0; i < series.length; i++) {
						endValue = startValue + series[i].pieData.value;
						// console.log(series[i]);
						series[i].pieData.startRatio = startValue / sumValue;
						series[i].pieData.endRatio = endValue / sumValue;
						series[i].parametricEquation = getParametricEquation(series[i].pieData.startRatio, series[i]
							.pieData.endRatio,
							false, false, k, series[i].pieData.value);
						startValue = endValue;
						legendData.push(series[i].name);
					}
					// 准备待返回的配置项，把准备好的 legendData、series 传入。
					let option = {
						tooltip: {
							formatter: params => {
								if (params.seriesName !== 'mouseoutSeries') {
									return `${params.seriesName}<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>${option.series[params.seriesIndex].pieData.value}`;
								}
							}
						},
						legend: {
							data: legendData,
							itemWidth: 15, //色标图宽
							itemHeight: 7, //色标图高
							orient: 'vertical', //垂直显示  
							top: 50,
							right: 20,
							itemGap: 25, //色标间隔
							textStyle: {
								color: '#fff',
								fontSize: 14
							},
							formatter: function(params) {
								var legendIndex = 0;
								legendData3D.forEach(function(v, i) {
									if (v.name == params) {
										legendIndex = i;
									}
								});
								return params + " " + legendData3D[legendIndex].value + "人";
							}
						},
						xAxis3D: {
							min: -1,
							max: 1
						},
						yAxis3D: {
							min: -1,
							max: 1
						},
						zAxis3D: {
							min: -1,
							max: 1
						},
						grid3D: {
							show: false,
							boxHeight: 20,
							top: '0',
							left: '-20',
							bottom: '20',
							environment: "auto",
							viewControl: {
								distance: 300, //远近
								alpha: 30, //饼图X轴旋转
								beta: 50, //饼图Y轴旋转
							},

						},
						series: series
					};
					return option
				}

				let option = getPie3D(legendData3D, 2);
				myChart.setOption(option)
			},

		}
	}
</script>

<style lang="scss" scoped>
	//公用左侧gif
	.arrow-n-line {
		.arrow-up {
			width: 10px;
			height: 10px;
			background: url('../assets/arrow-up.png') 0 0 no-repeat;
			position: absolute;
			top: 0px;
			left: 0px;
		}

		.arrow-down {
			width: 10px;
			height: 10px;
			background: url('../assets/arrow-down.png') 0 0 no-repeat;
			position: absolute;
			bottom: 0px;
			left: 0px;
		}

		&::before {
			content: '';
			width: 8px;
			background: url('../assets/left.gif') left -1px repeat-y;
			display: block;
			height: calc(100% - 24px);
			position: absolute;
			top: 10px;
			left: 0px;
		}

		&::after {
			content: '';
			width: 1px;
			background: #1ac9ff;
			display: block;
			height: 100%;
			position: absolute;
			top: 0px;
			right: 0px;
		}

	}

	.wrapper {
		width: 100vw;
		min-height: 100vh;
		background: #010429;
		overflow: hidden;

		.titbar {
			width: 100%;
			height: 130px;
			position: relative;
			text-align: center;
			color: #1ac9ff;
			font-size: 60px;


			.bg-tit {
				position: absolute;
				top: 0px;
				left: 50%;
				margin-left: -960px;
			}

			span {
				position: relative;
				top: 10px;

				&:hover {
					text-shadow: 0 0 10px #1ac9ff, 0 0 20px #1ac9ff, 0 0 30px #1ac9ff, 0 0 40px #1ac9ff; //设置发光效果
				}
			}

			.dot-l {
				position: absolute;
				top: -10px;
				left: 50%;
				margin-left: -650px;
			}

			.dot-r {
				position: absolute;
				top: 8px;
				left: 50%;
				margin-left: 600px;
				transform: rotate(180deg);
			}
		}

		.container {
			padding: 0 30px;

			.cont-left {
				width: calc(100% - 1010px);
				height: calc(100% - 130px);
				overflow: hidden;
				float: left;

				.area1 {
					width: 100%;
					display: flex;
					background: url('../assets/bg-char1.png');
					background-size: 100% 100%;
					position: relative;
					margin-top: 20px;


					.item {
						position: relative;
						padding-left: 30px;

						&.first {
							width: 380px;

							.char {
								width: 100%;
								height: 230px;
							}
						}

						&.last {
							width: calc(100% - 380px);

							.char {
								width: 100%;
								height: 230px;
							}
						}

						.tit {
							position: absolute;
							top: 10px;
							left: 40px;
							color: #1ac9ff;
							font-size: 18px;
							padding-left: 20px;
							background: url('../assets/bg-arrow.png') left center no-repeat;
							display: flex;

							.age {
								color: #ffffff;
								font-size: 14px;
								padding-left: 20px;

								span {
									font-size: 20px;
									color: #1ac9ff;
								}
							}

						}

					}

				}

				.area2 {
					width: 100%;
					height: 410px;
					display: flex;
					background: url('../assets/bg-char2.png') left top repeat-y;
					background-size: 100% 100%;
					margin-top: 20px;
					position: relative;


					.item {
						position: relative;
						padding-left: 30px;

						.char-wrap {
							width: 400px;
							height: 400px;
							position: relative;

							.circle {
								width: 148px;
								height: 148px;
								background: url('../assets/circle.png') center no-repeat;
								position: absolute;
								left: 50%;
								top: 50%;
								margin: -74px 0 0 -74px;
							}
						}

						&.first {
							width: 380px;

							.char {
								width: 100%;
								height: 400px;
							}
						}

						&.last {
							width: calc(100% - 380px);

							.char {
								width: 100%;
								height: 400px;
							}
						}

						.tit {
							position: absolute;
							top: 10px;
							left: 40px;
							color: #1ac9ff;
							font-size: 18px;
							padding-left: 20px;
							background: url('../assets/bg-arrow.png') left center no-repeat;
						}

					}

				}

				.area3 {
					width: 100%;
					height: 250px;
					display: flex;
					background: url('../assets/bg-char2.png') left top repeat-y;
					background-size: 100% 100%;
					position: relative;

					.item {
						position: relative;
						padding-left: 30px;

						&.first {
							width: 380px;

							.char {
								width: 100%;
								height: 250px;
							}
						}

						&.last {
							width: calc(100% - 380px);

							.char {
								width: 100%;
								height: 250px;
							}
						}

						.tit {
							position: absolute;
							top: 10px;
							left: 40px;
							color: #1ac9ff;
							font-size: 18px;
							padding-left: 20px;
							background: url('../assets/bg-arrow.png') left center no-repeat;
						}

					}

				}





			}

			.cont-center {
				width: 500px;
				height: 100%;
				float: left;
				margin-left: 20px;

				.area4 {
					width: 460px;
					height: 200px;
					padding: 0 20px;
					display: flex;
					justify-content: space-evenly;
					background: url('../assets/bg-char4.png') center repeat;
					position: relative;

					.item {
						width: 125px;
						text-align: center;
						color: #ffffff;
						background-size: 86px 130px;

						.num {
							margin-top: 40px;
							font-size: 20px;
							font-weight: bold;
						}

						.txt {
							margin-top: 90px;
							font-size: 18px;
						}

					}

					.item1 {
						background: url('../assets/count1.png') center 60px no-repeat;
					}

					.item2 {
						background: url('../assets/count2.png') center 60px no-repeat;
					}

					.item3 {
						background: url('../assets/count3.png') center 60px no-repeat;
					}

					.item4 {
						background: url('../assets/count4.png') center 60px no-repeat;
					}


				}

				.area5 {
					width: 100%;
					height: 460px;
					display: flex;
					background: url('../assets/bg-char2.png') left top repeat-y;
					background-size: 100% 100%;
					margin-top: 20px;
					position: relative;

					&::before {
						content: '';
						width: 8px;
						background: url('../assets/left.gif') left -1px repeat-y;
						display: block;
						height: calc(100% - 20px);
						position: absolute;
						top: 10px;
						left: 0px;
					}

					.item {
						position: relative;
						padding-left: 30px;

						width: 500px;

						.char {
							width: 100%;
							height: 420px;
						}

						.tit {
							position: absolute;
							top: 10px;
							left: 40px;
							color: #1ac9ff;
							font-size: 18px;
							padding-left: 20px;
							background: url('../assets/bg-arrow.png') left center no-repeat;
						}

					}

				}



			}

			.cont-right {
				width: 460px;
				height: 100%;
				float: left;
				margin-left: 20px;

				.area6 {
					width: 100%;
					height: 300px;
					display: flex;
					background: url('../assets/bg-char2.png') left top repeat-y;
					background-size: 100% 100%;
					// border-right: 1px solid #1ac9ff;
					position: relative;

					&::before {
						content: '';
						width: 8px;
						background: url('../assets/left.gif') left -1px repeat-y;
						display: block;
						height: calc(100% - 20px);
						position: absolute;
						top: 10px;
						left: 0px;
					}

					.item {
						position: relative;
						padding-left: 30px;
						width: 100%;

						.char {
							width: 100%;
							height: 300px;
						}
					}

					.tit {
						position: absolute;
						top: 10px;
						left: 40px;
						color: #1ac9ff;
						font-size: 18px;
						padding-left: 20px;
						background: url('../assets/bg-arrow.png') left center no-repeat;
					}


				}

				.area7 {
					width: 100%;
					height: 360px;
					display: flex;
					background: url('../assets/bg-char2.png') left top repeat-y;
					background-size: 100% 100%;
					// border-right: 1px solid #1ac9ff;
					position: relative;
					margin-top: 20px;

					&::before {
						content: '';
						width: 8px;
						background: url('../assets/left.gif') left -1px repeat-y;
						display: block;
						height: calc(100% - 20px);
						position: absolute;
						top: 10px;
						left: 0px;
					}

					.item {
						position: relative;
						padding-left: 30px;
						width: 100%;

						.char {
							width: 100%;
							height: 350px;
						}
					}

					.tit {
						position: absolute;
						top: 10px;
						left: 40px;
						color: #1ac9ff;
						font-size: 18px;
						padding-left: 20px;
						background: url('../assets/bg-arrow.png') left center no-repeat;
					}


				}


			}

			.cont-bottom {
				width: 980px;
				height: 230px;
				float: left;
				margin: 20px 0 0 20px;

				.area8 {
					position: relative;

					&::before {
						content: '';
						width: 8px;
						background: url('../assets/left.gif') left -1px repeat-y;
						display: block;
						height: calc(100% - 20px);
						position: absolute;
						top: 10px;
						left: 0px;
					}

					.tit {
						position: absolute;
						top: 10px;
						left: 50px;
						color: #1ac9ff;
						font-size: 18px;
						padding-left: 20px;
						background: url('../assets/bg-arrow.png') left center no-repeat;
					}

					.char {
						width: 980px;
						height: 230px;
						background: url('../assets/bg-char1.png');
						background-size: 100% 100%;
					}
				}
			}
		}

	}
</style>